import { global } from '@/global';
import { sms } from "@/services/individual/login";
import { corporateSms } from "@/services/corporate/login";

export default {
	state: {
		accessToken: sessionStorage.getItem(global['ACCESS_TOKEN']) || null,
		refreshToken: sessionStorage.getItem(global['REFRESH_TOKEN']) || null,
		bankTpe: sessionStorage.getItem(global['BANK_TYPE']) || null,
		agitoCustomerNo: sessionStorage.getItem(global['AGITO_CUSTOMER_NO']) || null,
		isAgitoCustomer: sessionStorage.getItem(global['IS_AGITO_CUSTOMER']) || null,
		isVizyoneksCustomer: sessionStorage.getItem(global['IS_VIZYONEKS_CUSTOMER']) || null,
		vizyoneksCustomerNo: sessionStorage.getItem(global['VIZYONEKS_CUSTOMER_NO']) || null,
		userTckn: sessionStorage.getItem(global['USER_TCKN']) || null,
		userPhone: sessionStorage.getItem(global['USER_PHONE']) || null,
	},
	getters: {
		getAccessToken: state => state.accessToken,
		getRefreshToken: state => state.refreshToken,
		getBankType: state => state.bankTpe,
		getAgitoCustomerNo: state => state.agitoCustomerNo,
		getVizyoneksCustomerNo: state => state.vizyoneksCustomerNo,
		getUserPhone: state=> state.userPhone,
		getUserTckn: state => state.userTckn,
		getUserInfo: state => {
			return {
				tckn: state.userTckn,
				vizyoneksCustomerNo: state.vizyoneksCustomerNo,
				agitoCustomerNo: state.agitoCustomerNo,
				isAgitoCustomer: state.isAgitoCustomer,
				isVizyoneksCustomer: state.isVizyoneksCustomer,
				Phone: state.userPhone
			}
		},
	},
	mutations: {
		setAccessToken: (state, key) => state.accessToken = key,
		setRefreshToken: (state, key) => state.refreshToken = key,
		setBankType: (state, type) => state.bankTpe = type,
		setAgitoCustomerNo: (state, no) => state.agitoCustomerNo = no,
		setIsAgitoCustomer: (state, status) => state.isAgitoCustomerNo = status,
		setVizyoneksCustomerNo: (state, no) => state.vizyoneksCustomerNo = no,
		isVizyoneksCustomer: (state, status) => state.isVizyoneksCustomer = status,
		setUserTckn: (state, tckn) => state.userTckn = tckn,
		setUserPhone:(state,phone) => state.userPhone =phone,
		removeAccessToken: (state) => state.accessToken = null,
		removeRefreshToken: (state) => state.refreshToken = null,
		removeBankType: (state) => state.bankTpe = null,
		removeAgitoCustomerNo: (state) => state.agitoCustomerNo = null,
		removeIsAgitoCustomer: (state) => state.isAgitoCustomerNo = null,
		removeVizyoneksCustomerNo: (state) => state.vizyoneksCustomerNo = null,
		removeIsVizyoneksCustomer: (state) => state.isVizyoneksCustomer = null,
		removeUserTckn: (state) => state.userTckn = null,
		removeUserPhone: (state) => state.userPhone = null
	},
	actions: {
		async setAccessToken({ commit }, token) {

			sessionStorage.setItem(global["ACCESS_TOKEN"], token);

			commit('setAccessToken', token);

		},
		async setRefreshToken({ commit }, token) {

			sessionStorage.setItem(global["REFRESH_TOKEN"], token);

			commit('setRefreshToken', token);

		},
		async setBankType({ commit }, type) {

			sessionStorage.setItem(global["BANK_TYPE"], type);

			commit('setBankType', type);

		},
		async setUserTckn({ commit }, tckn) {

			sessionStorage.setItem(global["USER_TCKN"], tckn);

			commit('setUserTckn', tckn);

		},
		async setUserPhone({ commit }, tckn) {

			sessionStorage.setItem(global["USER_PHONE"], tckn);

			commit('setUserPhone', tckn);

		},
		async setTokens({ commit }, result) {

			sessionStorage.setItem(global["ACCESS_TOKEN"], result.accessToken);
			sessionStorage.setItem(global["REFRESH_TOKEN"], result.refreshToken);

			sessionStorage.setItem(global["AGITO_CUSTOMER_NO"], result.agitoCustomerNo);

			sessionStorage.setItem(global["VIZYONEKS_CUSTOMER_NO"], result.vizyoneksCustomerNo);

			sessionStorage.setItem(global["IS_AGITO_CUSTOMER"], result.isAgitoCustomer);

			sessionStorage.setItem(global["IS_VIZYONEKS_CUSTOMER"], result.isVizyoneksCustomer);

			commit('setAccessToken', result.accessToken);
			commit('setRefreshToken', result.refreshToken);
			commit('setAgitoCustomerNo', result.agitoCustomerNo);
			commit('setVizyoneksCustomerNo', result.vizyoneksCustomerNo);
			commit('setIsAgitoCustomer', result.isAgitoCustomer);
			commit('isVizyoneksCustomer', result.isVizyoneksCustomer);
		},
		async api({ dispatch }, form) {
			let response = await sms(form);
			response.result.refreshToken = form.refreshToken;
			await dispatch('setTokens', response.result);

			return response;
		},
		async corporateApi({ dispatch }, form) {
			let result = await corporateSms(form).then((response) => {
				response.result.refreshToken = form.refreshToken;
				return dispatch('setTokens', response.result);
			});

			return result;
		},
		async login({ dispatch }, form) {
			return await dispatch('api', form);
		},
		async corporateLogin({ dispatch }, form) {
			return await dispatch('corporateApi', form);
		},
		async logout({ commit }) {
			return new Promise((resolve) => {
				sessionStorage.removeItem(global['ACCESS_TOKEN']);
				sessionStorage.removeItem(global['REFRESH_TOKEN']);
				sessionStorage.removeItem(global['VIZYONEKS_CUSTOMER_NO']);
				sessionStorage.removeItem(global['AGITO_CUSTOMER_NO']);
				sessionStorage.removeItem(global['IS_AGITO_CUSTOMER']);
				sessionStorage.removeItem(global['IS_VIZYONEKS_CUSTOMER']);
				sessionStorage.removeItem(global['BANK_TYPE']);
				sessionStorage.removeItem(global['USER_TCKN']);
				sessionStorage.removeItem(global['USER_PHONE']);
				commit('removeAccessToken');
				commit('removeRefreshToken');
				commit('removeBankType');
				commit('removeAgitoCustomerNo');
				commit('removeVizyoneksCustomerNo');
				commit('removeUserTckn');
				commit('removeUserPhone');
				commit('removeIsAgitoCustomer');
				commit('removeIsVizyoneksCustomer');
				resolve(true)
			})
		}
	}
}